import { Component, computed, inject, input } from '@angular/core';
import { EmailDetails } from '../../services/document-email.service';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { DateFormatPipe, MomentModule } from 'ngx-moment';
import { ConfigService } from '../../services/config.service';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'app-status-icon',
  standalone: true,
  imports: [MatIcon, MatTooltip, MomentModule],
  template: `
    @if (icon()) {
      <span [style.color]="color()">
        <mat-icon [matTooltip]="tooltip()">{{ icon() }}</mat-icon>
      </span>
    }
  `,
  providers: [DateFormatPipe]
})
export class StatusIconComponent {
  dateFormat = ConfigService.dates.shortDateTimeFormat;
  email = input.required<EmailDetails>();
  datePipe = inject(DateFormatPipe);

  icon = computed(() => {
    if (this.email().opened_at?.length) {
      return 'done_all';
    } else if (this.email().delivered_at) {
      return 'done';
    } else if (this.email().failed_at) {
      return 'error';
    } else {
      return 'schedule';
    }
  });

  color = computed(() => {
    if (this.email().opened_at?.length) {
      return '#4CAF50';
    } else if (this.email().delivered_at) {
      return 'rgb(179, 171, 150)';
    } else if (this.email().failed_at) {
      return '#F44336';
    } else {
      return 'rgb(179, 171, 150)';
    }
  });

  tooltip = computed(() => {
    if (this.email().opened_at?.length) {
      return `Opened at ${this.email()
        .opened_at.map((od) => this.datePipe.transform(od, this.dateFormat))
        .join(', ')}`;
    } else if (this.email().delivered_at) {
      return `Delivered at ${this.datePipe.transform(this.email().delivered_at, this.dateFormat)}`;
    } else if (this.email().failed_at) {
      return `Failed at ${this.datePipe.transform(this.email().failed_at, this.dateFormat)}`;
    } else {
      return 'Pending delivery';
    }
  });
}
